module.exports = __webpack_public_path__ + "static/media/breadcrumb04.3f073cf8.png";